import { AppSidebar } from '@/components/app-sidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

export function MainContainer({ children }: { children: React.ReactNode }) {
    const isMobile = useIsMobile();
    return (
        <SidebarProvider
            style={
                {
                    '--sidebar-width': '18rem',
                    '--sidebar-width-icon': '3rem',
                    '--header-height': '3rem',
                } as React.CSSProperties
            }
        >
            <AppSidebar />
            <SidebarInset>
                <SidebarTrigger className='mt-2 ml-2' />
                <div className={cn('flex h-full max-h-[calc(100vh-36px)] flex-col', isMobile ? 'px-10' : 'px-4')}>
                    {children}
                </div>
            </SidebarInset>
        </SidebarProvider>
    );
}
